import {Link} from "react-router-dom";
export function MembershipPlansSection() {
  const plans = [
    {
      title: 'MONTH-TO-MONTH',
      price: '$179',
      features: [
        'Unlimited access to all group classes',
        '25% discount on workshops & 15% on private events',
        'Free mat rental'
      ],
      buttonText: 'Buy Now',
      note: 'Auto-Renewal, can be canceled 1 month in advance no questions asked',
      buttonColor: 'bg-[#F6980E] hover:bg-[#E5890D]',
      isPopular: true
    },
    {
      title: '1-MONTH PREPAID',
      price: '$209',
      features: [
        'Unlimited access to all group classes'
      ],
      buttonText: 'Buy Now',
      note: 'Conditions applied, non-refundable except for medical issues',
      buttonColor: 'bg-[#00889D] hover:bg-[#007089]'
    },
    {
      title: '3-MONTH PREPAID',
      price: '$599',
      features: [
        'Unlimited access to all group classes',
        '$166/month'
      ],
      buttonText: 'Buy Now',
      note: 'Conditions applied, non-refundable except for medical issues',
      buttonColor: 'bg-[#00889D] hover:bg-[#007089]'
    },
    {
      title: '6-MONTH PREPAID',
      price: '$999',
      features: [
        'Unlimited access to all group classes',
        '$142/month',
        '25% discount on workshops & 15% on private events',
        'Free mat rental'
      ],
      buttonText: 'Buy Now',
      note: 'Conditions applied, non-refundable except for medical issues',
      buttonColor: 'bg-[#00889D] hover:bg-[#007089]'
    },
    {
      title: '12-MONTH PREPAID',
      price: '$1799',
      features: [
        'Unlimited access to all group classes',
        '$125/month',
        '25% discount on workshops & 15% on private events',
        'Free mat rental'
      ],
      buttonText: 'Buy Now',
      note: 'Conditions applied, non-refundable except for medical issues',
      buttonColor: 'bg-[#00889D] hover:bg-[#007089]'
    }
  ];

  return (
    <section className="py-8 pt-12">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#00889D] mb-4 md:mb-12">Monthly Memberships</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {plans.map((plan, index) => (
            <div key={index} className={`price-box bg-white rounded-2xl p-8 shadow-lg flex flex-col relative ${plan.isPopular ? 'border-2 border-[#F6980E]' : 'border-2 border-gray-200'}`}>
              {/* Header with title and price */}
              <div className="title flex justify-between items-start mb-6">
                <div className="text-[#00889D] font-bold text-lg">{plan.title}</div>
                <div className="flex flex-col items-end">
                  {plan.isPopular && (
                    <div className="absolute text-[#F6980E] font-bold text-sm mb-1" style={{top: "13px"}}>POPULAR</div>
                  )}
                  <div className="text-4xl font-bold text-[#00889D]">{plan.price}</div>
                </div>
              </div>
              
              {/* Features list */}
              <div className="space-y-3 mb-8 flex-grow">
                {plan.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-start">
                    <i className="ri-check-line text-[#00889D] mr-3 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700 text-left">{feature}</span>
                  </div>
                ))}
              </div>

              <Link to="/buy-now" className={`block w-full py-4 px-6 rounded-lg text-white font-semibold whitespace-nowrap cursor-pointer ${plan.buttonColor} text-lg mb-4 text-center`}>
                {plan.buttonText}
              </Link>

              {/* Note */}
              <div className="text-sm text-gray-500 text-center">
                {plan.note}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}